import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { membersAPI } from '../../services/api';
import { useToast } from '../../context/ToastContext';
import { CATEGORY_LABELS } from '../../utils/membership';
import './Pos.css';

const categories = Object.entries(CATEGORY_LABELS);

const MemberCreate = () => {
  const navigate = useNavigate();
  const { success, error } = useToast();
  const [form, setForm] = useState({
    chinese_name: '',
    english_name: '',
    phone_number: '',
    password: '',
    email: '',
    district: '',
    notes: '',
    birth_year: '',
    member_category: 'regular',
    membership_expires_on: '',
  });
  const [preview, setPreview] = useState(null);
  const [saving, setSaving] = useState(false);

  const setField = (name, value) => setForm((current) => ({ ...current, [name]: value }));

  const generatePassword = () => {
    const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
    let value = '';
    for (let i = 0; i < 10; i += 1) value += alphabet[Math.floor(Math.random() * alphabet.length)];
    setField('password', value);
    success('已產生臨時密碼，請抄下後再建立。此密碼只顯示這一次。');
  };

  const errorText = (err, fallback) => {
    const data = err.response?.data;
    if (!data) return fallback;
    return data.phone_number || data.password || data.name || data.error || fallback;
  };

  const submit = async () => {
    setSaving(true);
    try {
      const response = await membersAPI.create({
        ...form,
        birth_year: form.birth_year || null,
        membership_expires_on: form.membership_expires_on || null,
      });
      success('會員已建立');
      navigate(`/admin/members/${response.data.id}`);
    } catch (err) {
      error(errorText(err, '建立失敗'));
    } finally {
      setSaving(false);
    }
  };

  const start = async (event) => {
    event.preventDefault();
    setPreview(null);
    try {
      const response = await membersAPI.preview({
        phone: form.phone_number,
        email: form.email,
      });
      const body = response.data;
      if (body.phone || (body.emails && body.emails.length)) {
        setPreview(body);
        return;
      }
      await submit();
    } catch (err) {
      error(errorText(err, '檢查重複失敗'));
    }
  };

  return (
    <div className="pos-card">
      <h1>新增會員</h1>
      <form className="pos-form-grid" onSubmit={start}>
        <label>中文姓名
          <input value={form.chinese_name} onChange={(e) => setField('chinese_name', e.target.value)} />
        </label>
        <label>英文姓名
          <input value={form.english_name} onChange={(e) => setField('english_name', e.target.value)} />
        </label>
        <label>手機
          <input value={form.phone_number} onChange={(e) => setField('phone_number', e.target.value)} required />
        </label>
        <label>密碼
          <input type="text" value={form.password} onChange={(e) => setField('password', e.target.value)} required autoComplete="new-password" />
        </label>
        <div className="pos-actions">
          <button type="button" className="pos-btn secondary" onClick={generatePassword}>產生臨時密碼</button>
        </div>
        <label>電郵
          <input value={form.email} onChange={(e) => setField('email', e.target.value)} />
        </label>
        <label>地區
          <input value={form.district} onChange={(e) => setField('district', e.target.value)} />
        </label>
        <label>出生年份（可留空）
          <input value={form.birth_year} onChange={(e) => setField('birth_year', e.target.value)} inputMode="numeric" />
        </label>
        <label>會員類別
          <select value={form.member_category} onChange={(e) => setField('member_category', e.target.value)}>
            {categories.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </select>
        </label>
        <label>會籍到期日（留空表示無到期）
          <input type="date" value={form.membership_expires_on} onChange={(e) => setField('membership_expires_on', e.target.value)} />
        </label>
        <label>備註
          <textarea value={form.notes} onChange={(e) => setField('notes', e.target.value)} />
        </label>
        <div className="pos-actions">
          <button type="submit" className="pos-btn" disabled={saving}>{saving ? '建立中...' : '新增會員'}</button>
        </div>
      </form>

      {preview && (
        <section className="pos-section">
          <h2>可能已是會員</h2>
          {preview.phone && (
            <p>
              電話已有會員：{preview.phone.chinese_name} · {preview.phone.member_number}
              {' '}
              <a href={`/admin/members/${preview.phone.id}`}>開啟會員卡</a>
            </p>
          )}
          {(preview.emails || []).map((row) => (
            <p key={row.id}>
              電郵相近：{row.chinese_name} · {row.member_number}
              {' '}
              <a href={`/admin/members/${row.id}`}>開啟會員卡</a>
            </p>
          ))}
          <div className="pos-actions">
            <button type="button" className="pos-btn secondary" onClick={() => setPreview(null)}>取消</button>
            {!preview.phone && (
              <button type="button" className="pos-btn" onClick={submit} disabled={saving}>仍要建立</button>
            )}
          </div>
          {preview.phone && <p className="pos-hint">電話已被使用，不能覆蓋現有會員。</p>}
        </section>
      )}
    </div>
  );
};

export default MemberCreate;
